import { DAYS, POSTS } from "@/pages/allAnalytics/constants";
import { getDifferenceBetweenFirstAndLastValues, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils";

export const googleFollowersGrowthConfig = [
    {
        plotName: "business_profile_interactions",
        metricName: "business_profile_interactions",
        sumMetrics: false,
        title: "analytics_growth.business_profile_interactions",
        helpText: "analytics_growth.total_number_of_business_profile_interactions",
        cssIcon: "fa-duotone fa-solid fa-handshake",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "website_clicks",
        metricName: "website_clicks",
        sumMetrics: false,
        title: "analytics_growth.website_clicks",
        helpText: "analytics_growth.users_who_clicked_on_your_website_recently",
        cssIcon: "fa-duotone fa-solid fa-mouse-pointer",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
]

export const googlePlatformActionsConfig = [
    {
        plotName: "messages",
        metricName: "messages",
        sumMetrics: false,
        title: "analytics_growth.messages",
        helpText: "analytics_growth.total_number_of_messages_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-envelope",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "calls",
        metricName: "calls",
        sumMetrics: false,
        title: "analytics_growth.calls",
        helpText: "analytics_growth.total_number_of_calls_google",
        cssIcon: "fa-duotone fa-solid fa-phone-alt",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
]

export const googlePlatformImpressionsConfig = [
    {
        plotName: "impressions_desktop",
        metricName: "maps",
        sumMetrics: false,
        title: "analytics_growth.maps",
        helpText: "analytics_growth.total_number_of_maps_impressions",
        cssIcon: "fa-duotone fa-solid fa-map-marked-alt",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "impressions_desktop",
        metricName: "search",
        sumMetrics: false,
        title: "analytics_growth.search",
        helpText: "analytics_growth.total_number_of_search_impressions",
        cssIcon: "fa-duotone fa-solid fa-search",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "impressions_mobile",
        metricName: "maps",
        sumMetrics: false,
        title: "analytics_growth.maps",
        helpText: "analytics_growth.total_number_of_maps_impressions",
        cssIcon: "fa-duotone fa-solid fa-map-marked-alt",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "impressions_mobile",
        metricName: "search",
        sumMetrics: false,
        title: "analytics_growth.search",
        helpText: "analytics_growth.total_number_of_search_impressions",
        cssIcon: "fa-duotone fa-solid fa-search",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
]
